export default "__VITE_ASSET__19a83105__"